<div class="modal is-active" role="dialog" aria-modal="true">
  <div class="modal-background"></div>
  <div class="modal-card">
    <form [formGroup]="form" (ngSubmit)="confirm()">

      <header class="modal-card-head">
        <p class="modal-card-title">Add Adjustment</p>
      </header>
      <section class="modal-card-body" style="min-width: 800px;">

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Adjustment Type</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <div class="select is-fullwidth">
                  <select formControlName="isSetPriceMode">
                    <option [ngValue]="false">Enter Discount Amount</option>
                    <option [ngValue]="true">Set Total Payable</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">{{ !form.controls.isSetPriceMode.value ? "Discount Amount ($)" : "Set Total Payable To ($)" }}</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" type="number" min="0.0" step="0.01" formControlName="amount">
              </div>
              @if (form.controls.amount.touched && form.controls.amount.errors?.['amount']) {
                <small class="help is-danger">
                  {{ form.controls.amount?.getError('amount') }}
                </small>
              }
              @if (form.controls.isSetPriceMode.value && form.controls.amount.value !== null && !form.controls.amount.errors?.['amount'] && (CitationPrice - form.controls.amount.value) > 0) {
                <small class="help is-info">
                  A discount of {{ CitationPrice - form.controls.amount.value | currency }} will be applied to make the total {{ form.controls.amount.value | currency }}.
                </small>
              }
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Reason</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control is-expanded">
                <textarea class="textarea" rows="3" maxlength="512" formControlName="reason"
                placeholder="A reason is required..."></textarea>
              </div>
              @if (form.controls.reason.touched && form.controls.reason.errors?.['required']) {
                <small class="help is-danger">
                  Reason is required.
                </small>
              }
              @if (form.controls.reason.touched && form.controls.reason.errors?.['maxlength']) {
                <small class="help is-danger">
                  Reason cannot be longer than 512 characters.
                </small>
              }
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Notes (Optional)</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control is-expanded">
                <textarea class="textarea" rows="3" maxlength="2048" placeholder="Add any additional notes..." formControlName="notes"></textarea>
              </div>
              @if (form.controls.notes.touched && form.controls.notes.errors?.['maxlength']) {
                <small class="help is-danger">
                  Notes cannot be longer than 2048 characters.
                </small>
              }
            </div>
          </div>
        </div>

      </section>
      <footer class="modal-card-foot">
        <button class="button has-background-white mr-2" (click)="close()">
          <span class="icon"><i class="fa fa-xmark"></i></span><span>Cancel</span>
        </button>
        <app-modal-save-button [Disabled]="form.invalid || isSubmitting" (OnSave)="confirm()">
        </app-modal-save-button>
      </footer>

    </form>
  </div>
</div>
